import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import style from './HeaderComponents.module.css';
import { isMobile } from '../../config';

const HeaderComponents = ({ pageKey }) => {
    const headerData = require('./HeaderData').default;

    const { image, m_image, title, descript } = headerData[pageKey];

    return (
        <div className={style.componentsDiv} draggable>
            <div className={style.components}>
                <div className={style.imgDiv}>
                    <img src={ isMobile() ? m_image : image } alt={title} />
                </div>
                {isMobile() ? (<></>) : (<div className={style.recDiv}></div>)}
                <div className={style.compDiv}>
                    <p className={`fw-700 ${style.title}`}>{title}</p>
                    <p className={`fw-500 ${style.descript}`}>{descript}</p>
                </div>
            </div>
        </div>
    );
};

HeaderComponents.propTypes = {
    pageKey: PropTypes.string.isRequired,
};

export default HeaderComponents;
